"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAddress = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var Autosuggest = require("react-autosuggest");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var modalHeader_1 = require("../../../actions/modalHeader");
var addresses_2 = require("../../../actions/addresses");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("./constants");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var page = require("page");
/**
 * Update address component
 * @author pkatoria
 */
var UpdateAddress = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateAddress, _super);
    function UpdateAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.getWalletLink = function () {
            var walletLinkComponent, walletUrl = _this.props.links.wallet.linkUrl;
            var deviceType = commonweb_utils_1.objectUtils.safeGet(_this.props.deviceInfo, "deviceType");
            if (deviceType === "WEBVIEW") {
                walletLinkComponent = _this.props.addressContent.walletLink;
            }
            else {
                walletLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.addressContent.walletLink, href: walletUrl }, _this.props.addressContent.walletLink));
            }
            return walletLinkComponent;
        };
        _this.billingAddressInfo = function () {
            var cards = "", cardList = _this.state.addressToUpdate.cardList;
            var billingInfoContent;
            var count = 1;
            if (cardList) {
                cardList.forEach(function (card) {
                    var cardName = card.fullName ? card.fullName : card.name;
                    if (cardName) {
                        if (count > 1) {
                            cards = cards + ", ";
                        }
                        cards = cards + cardName + " ( ••••" + card.lastFour + ")";
                        count++;
                    }
                });
            }
            if (cardList) {
                if (_this.state.addressToUpdate.paypalCredit) {
                    billingInfoContent = _this.props.addressContent.info
                        .paypalCreditWithCards;
                }
                else {
                    billingInfoContent = _this.props.addressContent.info.cards;
                }
            }
            else if (_this.state.addressToUpdate.paypalCredit) {
                billingInfoContent = _this.props.addressContent.info.paypalCredit;
            }
            var walletLinkComponent = _this.getWalletLink();
            var cardsContent = interpolate_component_1.InterpolateLinksWithComponent(billingInfoContent, [
                cards,
                walletLinkComponent,
            ]);
            return cardsContent;
        };
        // Autosuggest will call this function every time you need to update suggestions.
        // You already implemented this logic above, so just use it.
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: _this.getSuggestions(value),
            });
        };
        // Teach Autosuggest how to calculate suggestions for any given input value.
        //TODO: Deepa please check this
        _this.getSuggestions = function (value) {
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            return inputLength === 0
                ? _this.props.stateList
                : _this.props.stateList.filter(function (state) {
                    return state.label.toLowerCase().slice(0, inputLength) ===
                        inputValue;
                });
        };
        // When suggestion is clicked, Autosuggest needs to populate the input
        // based on the clicked suggestion.
        _this.getSuggestionValue = function (suggestion) { return suggestion.label; };
        // render suggestions.
        _this.renderSuggestion = function (suggestion) { return (React.createElement("div", { className: "listItem" },
            React.createElement(pp_react_1.Text, { size: "md" }, suggestion.label))); };
        _this.renderInput = function (inputProps) { return (React.createElement("div", null,
            React.createElement(pp_react_1.TextInput, tslib_1.__assign({ name: "help", value: "", label: "Search State", leftIcon: React.createElement(pp_react_1.Icon, { size: "sm", name: "search" }) }, inputProps)))); };
        // start : SearcBox related functions
        // Called when user types in the text input of list page for searching state name
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            if (method !== "click") {
                _this.setState({
                    value: newValue,
                });
            }
            else {
                if (method === "click") {
                    _this.passValueToDropdown(newValue);
                }
            }
        };
        /* passing selected value from list page to the dropdown*/
        _this.passValueToDropdown = function (newValue) {
            var selectedState = _this.props.stateList.find(function (state) { return state.label === newValue; });
            var updatedForm = tslib_1.__assign({}, _this.props.updatedForm);
            var updatedFormElement = tslib_1.__assign({}, updatedForm["state"]);
            updatedFormElement.value = selectedState.id;
            updatedFormElement.isValid = true;
            updatedForm["state"] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier in updatedForm) {
                formIsValid = updatedForm[inputIdentifier].isValid && formIsValid;
            }
            // update the chosen state on the edit and address page
            _this.setState({
                form: updatedForm,
                formIsValid: true,
                openListPage: false,
                value: selectedState.label,
                label: selectedState.label,
            });
            _this.props.updateForm(updatedForm);
            window.history.go(-1);
            return false;
        };
        _this.getListPage = function () {
            //start : Autosuggestion related
            //@ts-ignore
            var _a = _this.state, value = _a.value, suggestions = _a.suggestions;
            var inputProps = {
                value: value,
                type: "search",
                onChange: _this.onChange,
                passValueToDropdown: _this.passValueToDropdown,
            };
            var closeFlag;
            if (commonweb_utils_1.objectUtils.safeGet(_this.props.deviceInfo, "deviceType") === "WEBVIEW") {
                closeFlag = false;
            }
            else {
                closeFlag = true;
            }
            function shouldRenderSuggestions(value) {
                return value.trim().length > -1;
            }
            //end Autosuggestion related
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("table", { className: "listPageInput" },
                        React.createElement("tr", null,
                            React.createElement("td", { className: "listPageInput_space_left" }),
                            React.createElement("td", { className: "listPageInput_space_centre" },
                                React.createElement("div", null,
                                    React.createElement(pp_react_1.Text, { size: "md", medium: true }, _this.props.addressContent.select.state))),
                            React.createElement("td", { className: "listPageInput_space_right" }, closeFlag ? (React.createElement("div", { onClick: _this.toggleListPageVisibility },
                                React.createElement(pp_react_1.Icon, { size: "sm", name: "close" }))) : (React.createElement(React.Fragment, null)))))),
                React.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: _this.onSuggestionsFetchRequested, getSuggestionValue: _this.getSuggestionValue, renderSuggestion: _this.renderSuggestion, focusInputOnSuggestionClick: false, inputProps: inputProps, renderSuggestionsContainer: _this.renderSuggestionsContainer, shouldRenderSuggestions: shouldRenderSuggestions, alwaysRenderSuggestions: true, renderInputComponent: _this.renderInput })));
        };
        _this.getErrorContent = function (errorContent) {
            var customerCareUrl = _this.props.links.help.linkUrl;
            var ccLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.commonContent.customerCareLink, href: customerCareUrl }, _this.props.commonContent.customerCareLink));
            var convertedErrorContent = interpolate_component_1.InterpolateLinksWithComponent(errorContent, [ccLinkComponent]);
            return convertedErrorContent;
        };
        _this.inputChangedHandler = function (event, formInputIdentifier) {
            if (!_this.state.formChanged) {
                _this.setState({ formChanged: true });
            }
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[formInputIdentifier]);
            updatedFormElement.value =
                event.target.type === "checkbox"
                    ? !updatedFormElement.value
                    : event.target.value;
            updatedFormElement.isValid = _this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.isTouched = true;
            updatedForm[formInputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier in updatedForm) {
                if (inputIdentifier !== "stateListInvoked") {
                    formIsValid =
                        updatedForm[inputIdentifier].isValid && formIsValid;
                }
            }
            _this.setState({ form: updatedForm, formIsValid: formIsValid });
        };
        _this.toggleListPageVisibility = function () {
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            updatedForm["stateListInvoked"] = true;
            _this.props.updateForm && _this.props.updateForm(updatedForm);
            var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.STATE.LIST;
            url = url.replace(":id", _this.state.addressToUpdate.id);
            page(url);
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.formIsValid ||
                _this.state.form.formIsValid ||
                !_this.state.formChanged) {
                _this.setState({ showSpinner: true });
                var formData = {};
                var addressContent_1 = _this.props.addressContent, alertMessage = _this.props.addressContent.alert
                    .editBillingAddress;
                var walletLinkComponent = _this.getWalletLink();
                var cardsContent = interpolate_component_1.InterpolateLinksWithComponent(alertMessage, [
                    walletLinkComponent,
                ]);
                if (_this.state.addressToUpdate.billing &&
                    _this.state.addressToUpdate.cardList) {
                    _this.setState({ errorMessage: cardsContent });
                    _this.setState({ showSpinner: false });
                }
                else {
                    for (var formElementIdentifier in _this.state.form) {
                        formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
                    }
                    formData["id"] = _this.props.route.enter.params.id;
                    formData["addresses"] = _this.props.addressData.addresses;
                    ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.EDIT, formData, { component: { name: VIEWS.ADDRESSES.UPDATE } })
                        .then(function (addressInfo) {
                        var returnUrl = null, fptiValue = null;
                        var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = commonUtils_1.isBaseFlowPresent(_this.props, ROUTES);
                        if (addressInfo) {
                            _this.props.dispatchUpdateAddress(addressInfo);
                            if (_this.state.form.primary.value) {
                                if (window &&
                                    window.venice &&
                                    typeof window.venice
                                        .primaryAddressModified === "function") {
                                    window.venice.primaryAddressModified();
                                }
                                _this.props.updateAction(VIEWS.ADDRESSES.TOAST_INTENTS.UPADTE_PRIMARY);
                                returnUrl = constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=setPrimaryAddress";
                                fptiValue = _this.props.addressFpti.addPrimary;
                            }
                            else {
                                _this.props.updateAction(VIEWS.ADDRESSES.TOAST_INTENTS.EDIT);
                                returnUrl = constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=editAddress";
                                fptiValue = _this.props.addressFpti.edit;
                            }
                        }
                        if (addressInfo.ppcSynchronyDeeplinks &&
                            Object.keys(addressInfo.ppcSynchronyDeeplinks)
                                .length !== 0) {
                            var ppcedit = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.EDIT_PPC;
                            page.redirect(ppcedit);
                        }
                        else {
                            if (isFlow && !isBaseFlowInHistory) {
                                triggerOperationResult_1.triggerOperationResult(fptiValue, FPTI.SUCCESS, null);
                                page(returnUrl);
                            }
                            else {
                                page.back();
                            }
                        }
                    })
                        .catch(function (error) {
                        _this.setState({ showSpinner: false });
                        if (error && error.userError) {
                            for (var i = 0; i < error.userError.errors.length; i++) {
                                var currentError = error.userError.errors[i];
                                if (currentError.name ===
                                    "ADDRESS_PATTERN_VALIDATION_ERROR" &&
                                    currentError.detail.field === "postal_code") {
                                    _this.setState({
                                        errorMsgPostalCode: addressContent_1.addUpdate
                                            .invalidZipCode,
                                    });
                                }
                            }
                            return;
                        }
                        var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500;
                        var errorDescFPTI;
                        beaver_logger_1.default().info(constants_2.ADDRESS.UPDATE_ADDRESS, {
                            errorCode: errorStatusCode,
                            message: error && error.message,
                        });
                        if (errorStatusCode >= 400 && errorStatusCode < 500) {
                            var code = addressErrors_1.errorCodes[error.errorKey];
                            var errorContent = _this.props.content.addresses
                                .error[code];
                            if (!errorContent) {
                                errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                            }
                            _this.setState({ errorMessage: errorContent });
                            errorDescFPTI = errorContent;
                        }
                        else {
                            var errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                            _this.setState({ errorMessage: errorContent });
                            errorDescFPTI = errorContent;
                        }
                        triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.edit, FPTI.FAILURE, errorDescFPTI);
                        return;
                    });
                }
            }
        };
        var country_code = _this.props.addressData.newAddress.country;
        var validationError = _this.props.addressContent.addUpdate
            .invalidZipCode;
        var addressAll = _this.props.addressData.addresses;
        var updateAddressId = _this.props.route.enter.params.id;
        var addressToUpdate = addressAll.find(function (addr) { return addr.id === updateAddressId; });
        var states = commonweb_utils_1.objectUtils.safeGet(_this.props, "addressData.newAddress.entryMetadata.properties.state");
        var properties = commonweb_utils_1.objectUtils.safeGet(_this.props, "addressData.newAddress.entryMetadata.properties");
        var stateList = states ? states.list : [];
        var _a = _this.getState(stateList, addressToUpdate), stateLabel = _a[0], stateId = _a[1];
        _this.state = {
            form: {
                line1: {
                    value: addressToUpdate.line1,
                    validation: {
                        required: true,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidStreet"),
                    },
                    isValid: true,
                    isTouched: false,
                },
                line2: {
                    value: addressToUpdate.line2,
                    validation: {
                        required: false,
                        suggestionText: " ",
                    },
                    isValid: true,
                    isTouched: false,
                },
                city: {
                    value: addressToUpdate.city,
                    validation: {
                        required: true,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidCity"),
                    },
                    isValid: true,
                    isTouched: false,
                },
                state: {
                    value: stateId ? stateId : addressToUpdate.state,
                    validation: {
                        required: true,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidState"),
                    },
                    isValid: true,
                    isTouched: false,
                },
                postal_code: {
                    value: addressToUpdate.postalCode,
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").required,
                        pattern: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "postal_code")
                                .validationPattern
                            ? commonweb_utils_1.objectUtils.safeGet(properties, "postal_code")
                                .validationPattern
                            : "",
                        maxlength: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").maxlength
                            ? commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").maxLength
                            : null,
                        suggestionText: validationError,
                    },
                    isValid: true,
                    isTouched: false,
                },
                country_code: {
                    value: country_code,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
                primary: {
                    value: addressToUpdate.primary !== "undefined"
                        ? addressToUpdate.primary
                        : false,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
            },
            formIsValid: false,
            errorMessage: "",
            showSpinner: false,
            formChanged: false,
            addressToUpdate: addressToUpdate ? addressToUpdate : "",
            value: stateId,
            label: stateLabel,
            suggestions: stateList,
            openListPage: false,
            errorMsgPostalCode: "",
        };
        return _this;
    }
    UpdateAddress.prototype.componentDidMount = function () {
        window.scroll({ top: 0, behavior: "smooth" });
        if (this.props.updatedForm) {
            this.setState({
                form: this.props.updatedForm,
            });
        }
    };
    UpdateAddress.prototype.getState = function (stateList, addressToUpdate) {
        var stateInfo = [], stateLabel, stateId;
        if (stateList && stateList.length > 0) {
            var stateMatchById = stateList.find(function (state) { return state.id === addressToUpdate.state; });
            var stateMatchByLabel = stateList.find(function (state) { return state.label === addressToUpdate.state; });
            stateLabel = stateMatchById
                ? stateMatchById.label
                : stateMatchByLabel
                    ? stateMatchByLabel.label
                    : " ";
            stateId = stateMatchById
                ? stateMatchById.id
                : stateMatchByLabel
                    ? stateMatchByLabel.id
                    : " ";
            stateInfo.push(stateLabel);
            stateInfo.push(stateId);
        }
        return stateInfo;
    };
    UpdateAddress.prototype.checkValidity = function (value, rules) {
        var isValid = true;
        if (!rules) {
            return true;
        }
        if (rules.required) {
            isValid = value.trim() !== "" && isValid;
        }
        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }
        if (rules.pattern) {
            var pattern = new RegExp("^" + rules.pattern + "$");
            isValid = pattern.test(value) && isValid;
        }
        return isValid;
    };
    UpdateAddress.prototype.inputElement = function (item, key, elementDisabled) {
        var _this = this;
        var formElement = tslib_1.__assign({}, this.state.form[key]);
        var isInputValid = this.state.formChanged
            ? formElement.isValid || !formElement.isTouched
            : true, disabled = elementDisabled;
        if (key === "line1") {
            return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                    ? formElement.validation.suggestionText
                    : "", disabled: disabled, id: key, className: "formFields_space", name: key, value: formElement.value, label: item.label, onChange: function (event) { return _this.inputChangedHandler(event, key); } }));
        }
        else if (key === "line2") {
            return (React.createElement(pp_react_1.TextInput, { disabled: disabled, id: key, className: "formFields_space", name: key, value: formElement.value, label: item.label, onChange: function (event) { return _this.inputChangedHandler(event, key); } }));
        }
        else if (key === "city") {
            if (item.list) {
                return (React.createElement(pp_react_1.Dropdown, { disabled: disabled, className: "formFields_space", name: key, value: formElement.value, label: item.label, placeholder: "", id: key, errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", options: item.list.map(function (city) {
                        return {
                            label: city.label,
                            value: city.id,
                        };
                    }), onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: disabled, className: "formFields_space", id: key, name: key, value: formElement.value, label: item.label, onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
        }
        else if (key === "state") {
            var selectedState = this.props.stateList &&
                this.props.stateList.find(function (state) { return state.id === formElement.value; });
            if (item.list) {
                return (React.createElement("div", null,
                    React.createElement(pp_react_1.Dropdown, { className: "formFields_space listPage_primary", errorText: "", disabled: disabled, value: formElement.value, name: key, label: item.label, placeholder: "", id: key, options: item.list.map(function (state) {
                            return {
                                label: state.label,
                                value: state.id,
                            };
                        }), onChange: function (event) {
                            return _this.inputChangedHandler(event, key);
                        } }),
                    React.createElement(pp_react_1.Dropdown, { className: "formFields_space listPage_secondary", errorText: "", disabled: disabled, name: key, value: formElement.value, label: item.label, placeholder: "", id: key, options: [
                            {
                                label: selectedState && selectedState.label,
                                value: selectedState && selectedState.value,
                            },
                        ], onFocus: this.toggleListPageVisibility })));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: disabled, className: "formFields_space", id: key, name: key, value: formElement.value, label: item.label, onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
        }
        else if (key === "postal_code") {
            isInputValid = this.state.formChanged
                ? commonweb_utils_1.objectUtils.safeGet(this.state, "form.postal_code.isValid") ||
                    !commonweb_utils_1.objectUtils.safeGet(this.state, "form.postal_code.isTouched")
                : true;
            return (React.createElement(pp_react_1.TextInput, { errorText: commonweb_utils_1.objectUtils.safeGet(this.state, "errorMsgPostalCode")
                    ? commonweb_utils_1.objectUtils.safeGet(this.state, "errorMsgPostalCode")
                    : !isInputValid
                        ? commonweb_utils_1.objectUtils.safeGet(this.state, "form.postal_code.validation.suggestionText")
                        : "", disabled: disabled, className: "formFields_space", id: "postal_code", name: "postal_code", value: this.state.form.postal_code &&
                    this.state.form.postal_code.value, label: item.label, onChange: function (event) {
                    return _this.inputChangedHandler(event, "postal_code");
                } }));
        }
    };
    /* Container to display sugestions */
    UpdateAddress.prototype.renderSuggestionsContainer = function (_a) {
        var containerProps = _a.containerProps, children = _a.children;
        return (React.createElement("div", null,
            React.createElement("div", { className: "listPage-divider" },
                React.createElement(pp_react_1.Divider, null)),
            React.createElement("div", { className: "suggestionContainer-body" },
                React.createElement("div", tslib_1.__assign({}, containerProps), children))));
    };
    UpdateAddress.prototype.render = function () {
        var _this = this;
        var addressFpti = this.props.addressFpti;
        var properties = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.properties"), layout = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.layout"), elementDisabled = this.state.showSpinner ||
            (this.state.addressToUpdate.billing &&
                this.state.addressToUpdate.cardList);
        var addressInput = layout.map(function (lines) {
            return lines.map(function (addressKey) {
                return _this.inputElement(properties[addressKey], addressKey, elementDisabled);
            });
        });
        var form = (React.createElement("form", { id: "update_address_form", onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, this.state.errorMessage)) : null,
            React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.props.addressContent.edit.header),
            addressInput,
            !this.state.addressToUpdate.primary &&
                !this.state.addressToUpdate.billing &&
                !this.state.addressToUpdate.primary &&
                !this.state.addressToUpdate.cardList ? (
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: "checkbox_space test_makeAddressPrimary", disabled: this.state.showSpinner, id: "primary", label: this.props.addressContent.addNewSetPrimary.checkBox, name: addressFpti.makePrimaryCheckbox, onChange: function (event) {
                    return _this.inputChangedHandler(event, "primary");
                } })) : null,
            this.state.addressToUpdate.billing ? (React.createElement("div", { className: "billingAddress-info" }, this.billingAddressInfo())) : null,
            React.createElement(pp_react_1.Button, { className: "addUpdateButton_space fullWidth test_UpdateAddressButton", name: addressFpti.submitUpdate, type: "submit" }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: this.props.commonContent.loading, inverse: true })) : (this.props.commonContent.update))));
        return React.createElement("div", null, form);
    };
    return UpdateAddress;
}(React.Component));
exports.UpdateAddress = UpdateAddress;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, deviceInfo = _a.deviceInfo;
    var addressData = account.addressData, addressFpti = fpti.address, states = commonweb_utils_1.objectUtils.safeGet(addressData, "newAddress.entryMetadata.properties.state"), stateList = states ? states.list : [], addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation, updatedForm = addressData.updatedForm;
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
        deviceInfo: deviceInfo,
        updatedForm: updatedForm,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        updateAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        updateForm: function (value) { return dispatch(addresses_2.updateForm(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateAddress);
